// import Chart from 'chart.js/auto';
function destroyHomeIndex() {
    destroyChart(document.getElementById('myChart'));
    // if(document.getElementById('home-index')) {
    //     destroyChart(document.getElementById('myChart'));
    // }
}

function setupHomeIndex() {
    if(document.getElementById('home-index')) {
        let canvas = document.getElementById('myChart');
        if(canvas === undefined || canvas === null){
            console.warn('chart element is missing!!\ncanvas:');
            console.log(canvas);
        } else {
            destroyChart(canvas);
            let ctx = canvas.getContext('2d');
            new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: JSON.parse(ctx.canvas.dataset.labels),
                    datasets: [{
                        label: 'Ultimos días de venta',
                        data: JSON.parse(ctx.canvas.dataset.data),
                    }]
                },
                options: {
                    responsive: true
                }
            });
            console.log("Chart created!");
        }
    }
}

function destroyChart(canvas) {
    if(canvas !== undefined && canvas !== null){
        let existingChart = Chart.getChart(canvas);
        if (existingChart) {
            existingChart.destroy();
            console.log("Chart destroyed!");
        }
    }
}

document.addEventListener("turbolinks:load", setupHomeIndex);
document.addEventListener('turbolinks:before-cache', destroyHomeIndex);

// Rails 7 & Hotwire/Turbo
// document.addEventListener('turbo:load', setupUserForm);
// document.addEventListener('turbo:before-cache', teardownUserForm);